// extracted by mini-css-extract-plugin
module.exports = {"vimeo-embed":"VimeoEmbed_vimeo-embed__YxObp"};